// Stub — per-user AI key storage. Returns null on this deployment (backend handles AI calls).
export function getAiKey() {
  return localStorage.getItem('vmai:ai-key') || null;
}

export function setAiKey(key) {
  if (key) localStorage.setItem('vmai:ai-key', key);
  else localStorage.removeItem('vmai:ai-key');
}
